<template>
  <div class="container">
    <div style="margin-bottom: 20px">
      <label style="margin-right: 8px">单据编号</label>
      <span v-if="!!inbound.id">{{ inbound.code }}</span>
      <el-input v-else v-model="inbound.code" style="width: 150px"></el-input>
      <label style="margin-left: 12px; margin-right: 8px">入库仓库</label>
      <span v-if="readOnly">{{ inbound.warehouseId | valueName('Warehouse') }}
      - {{ inbound.warehousePosId | valueName('WarehousePos') }}</span>
      <warehouse-select v-else v-model="inbound.warehouse"></warehouse-select>
      <label style="margin-left: 12px; margin-right: 8px">入库日期</label>
      <span v-if="readOnly">{{ inbound.inDate }}</span>
      <el-date-picker v-else style="max-width: 130px;"
                      v-model="inbound.inDate"
                      type="date"
                      format="yyyy-MM-dd"
                      placeholder="选择日期">
      </el-date-picker>
      <label style="margin-left: 12px; margin-right: 8px">经办人</label>
      <span v-if="readOnly">{{ inbound.operatorUserName }}</span>
      <remote-select v-else class-name="InboundUser" v-model="inbound.operatorUserAccount"
                     :options="inboundUserOptions" selectFirst>
      </remote-select>
    </div>
    <el-table :data="inbound.goodsList" class="table-border" header-cell-class-name="table-head"
              :max-height="tableHeight">
      <el-table-column type="index" label="序号"></el-table-column>
      <el-table-column label="商品名称" prop="name"></el-table-column>
      <el-table-column label="商品编号" prop="code"></el-table-column>
      <el-table-column label="商品类型">
        <template #default="{row}">
          {{ row.typeCode | valueName('GOODS_TYPE') }}
        </template>
      </el-table-column>
      <el-table-column label="单位" prop="unit"></el-table-column>
      <el-table-column label="单位2" prop="unit2"></el-table-column>
      <el-table-column label="单位2/单位" prop="unitRatio"></el-table-column>
      <el-table-column label="生产日期" prop="productionDate"></el-table-column>
      <el-table-column label="有效期（天）" prop="expireDays"></el-table-column>
      <el-table-column label="数量" prop="num"></el-table-column>
      <el-table-column label="单价（元）" prop="price"></el-table-column>
      <el-table-column label="上限" prop="upperBound"></el-table-column>
      <el-table-column label="下限" prop="lowerBound"></el-table-column>

      <el-table-column v-if="!readOnly" :width="120" align="center" fixed="right">
        <template #header>
          <el-button type="primary" @click="selectGoods">商品选择</el-button>
        </template>
        <template #default="{row}">
          <el-button type="text" size="mini" @click="deleteGoods(row)" class="danger">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="margin-top: 20px; display: flex">
      <label style="margin-right: 8px; width: 30px">备注</label>
      <el-input type="textarea" :rows="4" v-model="inbound.remarks" maxlength="200" resize="none"
                :disabled="readOnly"></el-input>
    </div>

    <div style="float: right; margin-top: 20px;">
      <template v-if="!readOnly">
        <el-button type="primary" @click="applyInbound">入 库</el-button>
        <el-button @click="save">保 存</el-button>
        <el-button @click="cancel">取 消</el-button>
      </template>
      <el-button v-else @click="cancel">返 回</el-button>
    </div>

    <select-goods-dialog :visible.sync="dialog.show" :inbound="dialog.inbound"
                         @update="updateGoodsList"></select-goods-dialog>
  </div>
</template>

<script>

import SelectGoodsDialog from '@/views/inbound/SelectGoodsDialog'
import { resizeCaptureMixin } from '@/views/mixins/ResizeCapture'
import WarehouseSelect from '@/components/selector/WarehouseSelect'
import RemoteSelect from '@/components/selector/RemoteSelect'
import { Inbound } from '@/store/objdef/objectDef'
import authority from '@/utils/authority'

export default {
  name: 'InboundGoods',
  mixins: [resizeCaptureMixin],
  components: { RemoteSelect, WarehouseSelect, SelectGoodsDialog },
  data () {
    return {
      inbound: new Inbound(),
      dialog: {
        show: false,
        inbound: new Inbound()
      }
    }
  },
  created () {
    this.$store.dispatch('data/kvList', 'InboundUser')
    this.$store.dispatch('inbound/all').then(list => {
      for (const inbound of list) {
        if (inbound.id.toString() === this.$route.query.inboundId) {
          this.inbound = inbound
          break
        }
      }
    })
  },
  methods: {
    selectGoods () {
      this.dialog.inbound = this.$_.cloneDeep(this.inbound)
      this.dialog.show = true
    },
    deleteGoods (goods) {
      this.$confirm(`确认删除商品【${goods.name}】, 是否继续?`, '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        for (const index in this.inbound.goodsList) {
          const item = this.inbound.goodsList[index]
          if (item.id === goods.id) {
            this.inbound.goodsList.splice(index, 1)
          }
        }
      }).catch(() => {
      })
    },
    updateGoodsList (goodsList) {
      this.inbound.goodsList = goodsList
    },
    applyInbound () {
      if (!this.check()) return
      this.inbound.status = 2
      this.save()
    },
    save () {
      if (!this.check()) return
      if (typeof this.inbound.inDate === 'object') {
        this.inbound.inDate = this.inbound.inDate.format('yyyy-MM-dd')
      }
      const isAdd = !this.inbound.id
      this.$store.dispatch('inbound/' + (isAdd ? 'add' : 'updateOne'), this.$_.cloneDeep(this.inbound)).then(() => {
        this.$router.go(-1)
        this.$message.success((this.inbound.status === 0 ? '保存' : '入库') + '成功!')
      })
    },
    cancel () {
      this.$router.go(-1)
    },
    check () {
      if (!this.inbound.warehouse || !this.inbound.warehouse[1]) {
        this.$alert('请选择仓库！')
        return false
      }
      if (!this.inbound.inDate) {
        this.$alert('请选择入库日期！')
        return false
      }
      return true
    }
  },
  computed: {
    tableHeight () {
      return this.clientHeight - 224 - 50
    },
    readOnly () {
      return this.inbound.status !== 0 || !this.$hasPermission(authority.INBOUND)
    },
    inboundUserOptions () {
      const options = [{ id: this.$store.state.user.userAccount, name: this.$store.state.user.name }]
      for (const item of this.$store.state.data.InboundUser || []) {
        options.push({ id: item.account, name: item.name })
      }
      return options
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ th {
  height: 50px;
}

label {
  margin-right: 10px;
  font-size: 13px;
  color: #646464;
}
</style>
